export enum PasswordType {
  SIGNUP = 'SIGNUP',
  RECOVERY = 'RECOVERY',
  CHANGE = 'CHANGE',
}
